<template>
    <div>
        <vs-card title="Background Putaway" class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Background Putaway</h4>
                </div>
                <div class="flex items-center">
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Save</vs-button>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col md:w-1/3 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Delivery Order ID" v-model="data.id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Reference" v-model="data.reference" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="Movement ID" v-model="data.movement_id" disabled/>
                        </div>
                    </div>

                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-full">
                            <label for="" class="vs-input--label">Movement Date *</label>
                            <flat-pickr class="w-full" v-model="data.movement_date"/>
                        </div>
                    </div>
                </div>
            </div>
        </vs-card>
        <vs-card title="Item Details" class="p-4 mb-6">
            <vs-button type="border" :disabled="selected.length < 1" @click="removeLine" class="mb-5">Remove</vs-button>
            <vs-table multiple v-model="selected" :data="put" stripe>
                <template slot="thead">
                    <vs-th>Line ID</vs-th>
                    <vs-th>Product ID</vs-th>
                    <vs-th>Description</vs-th>
                    <vs-th>Pack ID</vs-th>
                    <vs-th>Batch</vs-th>
                    <vs-th>Exp. Date</vs-th>
                    <vs-th>Qty</vs-th>
                    <vs-th>UoM</vs-th>
                    <vs-th>Stock Type</vs-th>
                    <vs-th>Location Type</vs-th>
                    <vs-th>Location ID</vs-th>
                    <vs-th>Storage Unit</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="tr.line_id">
                        {{ indextr + 1 }}
                    </vs-td>
 
                    <vs-td :data="tr.line_id">
                        {{ tr.product_code }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.description_1 }}
                    </vs-td> 
 
                    <vs-td :data="tr.line_id">
                        {{ tr.pack_id }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.batch }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.expired_date }}
                    </vs-td>
                    
                    <vs-td :data="tr.line_id">
                        {{ tr.base_qty}}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.base_uom_name }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.stock_type_name }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.location_type_code }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.location_code }}
                    </vs-td>

                    <vs-td :data="tr.line_id">
                        {{ tr.storage_unit }}
                    </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vs-card>
    </div>  
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select'

export default {
    components:{
        flatPickr,
        vSelect
    },
    data() {
        return {
            locationOption: [],
            isLoading: false,
            data: {
                id: '',
                movement_id: '',
                movement_date: new Date(),
                reference: '',
            },
            put: [],
            selected: [],
            drafts: [],
        }
    },
    watch: {
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        }

    },
    methods: {
        back() {
            this.$router.push({name: 'return-delivery-order-view', params: { id: this.$route.params.id }})
        },
        submitForm() {
            let error = false
            const moHead = {
                rdo_id: this.$route.params.id,
                movement_date: this.data.movement_date,
            }

            var details = []

            if(this.selected.length <= 0) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'No putaway line selected.'
                })
                return false
            }
            this.isLoading = true ;
            this.selected.map((item, index) => {
                if(item.location_id == '') {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Line ' + item.line_id + '. No location assigned'
                    })
                    error = true
                }
                else {
                    details.push(item.id)
                }
            })

            if(error) {
                this.isLoading = false ;
                return false
            }
            else {
                const dataSend = {
                    movement_order: JSON.stringify(moHead),
                    movement_order_details: JSON.stringify(details),
                }

                this.$http.post('outbound/returndeliveryorder/storeputaway', dataSend)
                .then(() => {
                    this.isLoading = false ;
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Saved successfully.'
                    })
                    this.$router.push({ name: 'return-delivery-order-view', params: {id: this.$route.params.id} })
                })
                .catch(error => this.handleError(error))
            }
        },
        removeLine() {
            let indexes = []
            this.selected.map(item => {
                this.put.map((detail, index) => {
                    if(detail.id == item.id) {
                        indexes.push(index)
                    }
                })
            })

            indexes.sort((a, b) => b - a)

            this.selected = []

            indexes.map(index => {
                this.put.splice(index, 1)
            })
        }
    },
    mounted() {
        this.data.id = this.$route.params.data.data_rdo.id
        this.data.reference = this.$route.params.data.data_rdo.reference
        let partitionData = [];

        this.$route.params.data.list_draftputaway.map(item => {
            item.data_status = 'submit'
            if(partitionData.length == 0) {
                partitionData.push([item])
            }
            else {
                let found = false
                for(let i = 0; i < partitionData.length; i++) {
                    if(partitionData[i][0].inventory_first_id == item.inventory_first_id) {
                        partitionData[i].push(item)
                        found = true
                        break
                    }
                }

                if(!found) {
                    partitionData.push([item])
                }
            }
        })

        this.drafts = partitionData
        this.put = this.$route.params.data.list_draftputaway
        this.selected = this.put

        this.drafts.map(item => {
            let totalItem = 0
            
            item.map(value => {
                totalItem += value.base_qty
            })

            item.map(value => {
                value.total_item = totalItem
            })
        })

        this.$vs.loading.close()
    }
}
</script>